import PropTypes from 'prop-types';
import React from 'react';
const propTypes = {
    label: PropTypes.string,
};
const defaultProps = {
    label: 'Loading...',
};
const Loader = ({ label }) => (React.createElement("div", { className: "rbt-loader spinner-border spinner-border-sm", role: "status" },
    React.createElement("span", { className: "sr-only visually-hidden" }, label)));
Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;
export default Loader;
